/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "aslanwebsftpapi",
            "endpoint": "https://vyv1rjbsm8.execute-api.eu-west-2.amazonaws.com/prd",
            "region": "eu-west-2"
        },
        {
            "name": "fileApi",
            "endpoint": "https://l9p21422kg.execute-api.eu-west-2.amazonaws.com/prd",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:9fef7fa7-7246-4dff-8a96-55eb46315ec9",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_SZj6bSOHM",
    "aws_user_pools_web_client_id": "5ms00m1c5ealetq040h2uq9uu4",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "userprofiles-prd",
            "region": "eu-west-2"
        },
        {
            "tableName": "companiesTable-prd",
            "region": "eu-west-2"
        }
    ]
};


export default awsmobile;
